module.exports = __webpack_public_path__ + "img/type(3).6ade40bc.png";